import React, { useContext } from 'react'

const QuestionVehiclesKeptOvernight = ({ reqVehicleContext, display = true }) => {
    const vehicleContext = useContext(reqVehicleContext);
    var addressFields = vehicleContext?.removeVehicleClass?.policyAddressFields
    
    if (!display) {
        return null;
    }

    return (
        <div className="row align-items-center my-3">
            <div className="col-12 col-md-6 text-primary fw-bold mb-2 mb-md-0">
                {`Will the vehicle(s) above be kept overnight at 
                ${addressFields?.address1} ${addressFields?.city} ${addressFields?.state} ${addressFields?.zip?.slice(0, 5)}?*`}
            </div>
            <div className="col-12 col-md-6 col-sm-8 text-dark">
                <label>{vehicleContext?.removeVehicleClass?.driverAssignment?.keptOvernight}</label>
            </div>
        </div>
    )
}

const IndentedContent = ({ content }) => (
    <div className="ms-3 mt-2 fw-bold" style={{ paddingRight: '20%' }}>
        {content}
    </div>
);

export { QuestionVehiclesKeptOvernight, IndentedContent };